<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "XingbieNianlin",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object,
      default() {
        return null;
      },
      legendList: null
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption({
        //backgroundColor: '#ccc',
        tooltip: {
          trigger: "axis",
          formatter: function(value) {
            return (
              value[0].name +
              "<br>" +
              value[0].seriesName +
              ": " +
              value[0].value +
              "%<br>" +
              value[1].seriesName +
              ": " +
              value[1].value.toString().replace("-", "") +
              "%"
            );
          },
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.chartData.legendList,
          icon: "rect",
          itemGap: 40,
          itemWidth: 14,
          itemHeight: 14,
          top: 18,
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 17
          }
        },
        grid: {
          left: 100,
          right: 100,
          bottom: 0,
          containLabel: true
        },
        xAxis: [
          {
            type: "value",
            axisTick: {
              show: false
            },
            min: -20,
            max: 20,
            splitNumber: 8,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#414f5a",
                type: "dashed"
              }
            },
            axisLine: {
              //坐标 轴线
              show: true, //是否显示坐标轴轴线
              lineStyle: {
                color: "#414f5a"
              }
            },
            axisLabel: {
              formatter: function(value) {
                var temp = value.toString().replace("-", "");
                return temp + "%";
              },
              textStyle: {
                fontWeight: "bold",
                color: "#fff",
                fontSize: 13.5
              }
            }
          },
          {
            type: "value",
            position: "top",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#1454a8"
              }
            }
          }
        ],
        yAxis: [
          {
            show: "true",
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                fontWeight: "bold",
                color: "#fff",
                fontSize: 13.5
              }
            },
            data: this.chartData.nameList
          },
           /* {
                type : 'value',
                name : '厂商新增数量',
                min : 0,
                max : 200,
                position : 'left',
                offset : 190,
                axisLine : {
                    lineStyle : {
                        color :"#fff"
                    }
                },
                splitNumber : 10,
                splitLine : {
                    show : true,
                    lineStyle : {
                        type : 'dashed'
                    }
                },
                splitArea : {
                    show : false
                }
                // axisLabel : {
                //     formatter : '{value}'
                // }
            }*/
        ],
        series: [
          {
            name: this.chartData.legendList[0],
            type: "bar",
            animationDuration: 4000,
            stack: "总量",
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#1482e9"
                    },
                    {
                      offset: 1,
                      color: "#00cee4"
                    }
                  ],
                  globalCoord: false
                }
              }
            },
            label: {
              normal: {
                show: false
              }
            },
            barWidth: 12,
            data: this.chartData.men.layer
          },
          {
            // name: "负面",
            name: this.chartData.legendList[1],

            type: "bar",
            stack: "总量",
            animationDuration: 4000,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fd563c"
                    },
                    {
                      offset: 1,
                      color: "#e76462"
                    }
                  ],
                  globalCoord: false
                }
              }
            },
            label: {
              normal: {
                show: false
              }
            },
            barWidth: 12,
            data: this.chartData.women.layer
          }
        ]
      });
    }
  }
};
</script>
